import { jsxs as v, jsx as h } from "react/jsx-runtime";
const r = (l) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M53.886 24.18V7.51H13.224a3.586 3.586 0 0 0-3.582 3.58v13.09h-1.97v9.195h1.97v16.21c0 1.93 1.57 3.5 3.5 3.5h2.467v3.397h8.597v-3.397h15.065v3.397h8.597v-3.397h3.086l-1.072-4h-36.24V37.231h36.242v11.852l4-1.072V33.375h1.957V24.18h-1.956ZM13.642 35.232V15.693H35.6l-7.07 19.538H13.643Zm36.242 0H30.657l7.07-19.538h12.159v19.538Zm0-21.538H13.644V11.51h36.242v2.184Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M20.008 45.218a1.996 1.996 0 1 0-.64-3.94 1.996 1.996 0 0 0 .64 3.94ZM44.234 45.218a1.996 1.996 0 1 0-.64-3.94 1.996 1.996 0 0 0 .64 3.94Z"
        }
      )
    ]
  }
);
export {
  r as Bus
};
